import { Fragment } from "react";
import Heading from "../UI/Heading";
import { AiOutlineClose } from "react-icons/ai";
import ImageCarousel from "../UI/ImageCarousel";

export default function BookingImages({ booking, setOpen }) {

  // Compile all images
  const checkInImages = [];
  if (booking.checkInImages) checkInImages.push(...booking.checkInImages);
  const checkOutImages = [];
  if (booking.checkOutImages) checkOutImages.push(...booking.checkOutImages);

  return (
    <Fragment>
      <Heading
        title="Booking Images"
        text="Images taken by admin and customer are shown collectively."
        isBackArrow={false}
        onClick={() => setOpen(false)}
      >
        <AiOutlineClose className="icon" onClick={() => setOpen(false)} />
      </Heading>
      <div className="grid gap-4 no-scrollbar">
        {checkInImages.length > 0 ? (
          <>
            <p className="text-base font-semibold text-stone-200">
              Check In Images:
            </p>
            <ImageCarousel
              images={checkInImages}
              preview={true}
            />
          </>
        ) : (
          <p className="text-sm text-stone-400">No check in images found.</p>
        )}
        {checkOutImages.length > 0 ? (
          <>
            <p className="text-base font-semibold text-stone-200">
              Check Out Images:
            </p>
            <ImageCarousel
              images={checkOutImages}
              preview={true}
            />
          </>
        ) : (
          <p className="text-sm text-stone-400">No check out images found.</p>
        )}
      </div>
    </Fragment>
  );
}
